import { AdminExecuteRefund, AdminFetchRefunds } from 'src/constants/actionTypes'
import type { FetchRefundsPayload, RefundsPage } from 'src/interfaces/refund'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { RefundState } from './types'

const getInitialState = (): RefundState => {
  return {
    refunds: [],
    pagination: {},
    loadedStatus: null,
    requestedStatus: null,
    loading: false,
    error: null,
    executing: false,
  }
}

export const refundReducer = (
  state: RefundState = getInitialState(),
  action: Action<unknown>,
): RefundState => {
  switch (action.type) {
    case AdminFetchRefunds.type.REQUEST: {
      const status = (action.payload as FetchRefundsPayload | undefined)?.status ?? null
      const isSameStatus = status === state.loadedStatus

      return {
        ...state,
        refunds: isSameStatus ? state.refunds : [],
        pagination: isSameStatus ? state.pagination : {},
        loadedStatus: isSameStatus ? state.loadedStatus : null,
        requestedStatus: status,
        loading: true,
        error: null,
      }
    }
    case AdminFetchRefunds.type.SUCCESS: {
      const page = action.payload as RefundsPage | undefined

      return {
        ...state,
        refunds: page?.data ?? [],
        pagination: page?.pagination ?? {},
        loadedStatus: state.requestedStatus,
        loading: false,
        error: null,
      }
    }
    case AdminFetchRefunds.type.FAILED:
      return {
        ...state,
        loading: false,
        error: resolveErrorMessage(action.payload, 'Failed to load refunds'),
      }

    case AdminExecuteRefund.type.REQUEST:
      return { ...state, executing: true }
    case AdminExecuteRefund.type.SUCCESS:
    case AdminExecuteRefund.type.FAILED:
      return { ...state, executing: false }

    default:
      return state
  }
}
